import "./LoaderSpinner.css";

export default function LoaderSpinner() {
  return <div className="loader"></div>;
}
